import { months } from "../../../../shared/data/months";

export const markDaysAvailable = (daysAvailable) => {
    const monthsItems = document.querySelectorAll("[class*=DatePicker_monthContainer__]");
    const datesDays = document.querySelectorAll("[class*=DatePicker_dateDayItem__]");
    datesDays.forEach(el => {
        el.classList.remove("react-calendar-horizontal-dayAvailable")
        el.classList.remove("react-calendar-horizontal-dayDisabled")
    });

    for (let index = 0; index < monthsItems.length; index++) {
        const month = monthsItems[index];

        const spanMonth = month.querySelector("[class*=DatePicker_monthYearLabel__]");
        const [monthName, year] = spanMonth.innerHTML.split(" ");
        const monthFinder = months.find(x => x.monthEs === monthName && monthName);
        const dateDayItem = month.querySelectorAll("[class*=DatePicker_dateDayItem__]");

        dateDayItem.forEach(el => {
            const dateLabel = el.querySelector("[class*=DatePicker_dateLabel__]")
            if (monthFinder) {
                const dateCompleted = `${year}${monthFinder.monthNumber}${Number(dateLabel.innerHTML) < 10 ? `0${dateLabel.innerHTML}` : dateLabel.innerHTML}`;
                const daysAvailableFormatted = daysAvailable.map(el => {
                    let [year, month, day] = el.ageInicio.split("/");
                    month = month < 10 ? `0${month}` : month;
                    day = day < 10 ? `0${day}` : day;

                    return `${year}${month}${day}`;
                })

                if (daysAvailableFormatted.find(day => day === dateCompleted)) {
                    el.classList.add("react-calendar-horizontal-dayAvailable")
                } else {
                    el.classList.add("react-calendar-horizontal-dayDisabled")
                }
            }
        })
    } 
}